import {graphql, usePreloadedQuery} from 'react-relay'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'

import TransformText from '../../../../../../containers/TransformText'
import type {BuildTypeId} from '../../../../../../types'
import styles from '../BuildStatusTooltip.css'

import type {BuildPersonalChangeCommentQuery} from './__generated__/BuildPersonalChangeCommentQuery.graphql'

export const personalChangeCommentQuery = graphql`
  query BuildPersonalChangeCommentQuery($changeLocator: String!) {
    change(changeLocator: $changeLocator) {
      comment
    }
  }
`

type Props = {
  queryRef: PreloadedQuery<BuildPersonalChangeCommentQuery>
  buildTypeId?: BuildTypeId | null | undefined
}

export default function BuildPersonalChangeComment({queryRef, buildTypeId}: Props) {
  const {change} = usePreloadedQuery(personalChangeCommentQuery, queryRef)
  const changeComment = change?.comment ?? 'No comment'
  return <TransformText text={changeComment} buildTypeId={buildTypeId} className={styles.comment} />
}
